export class SelectRating {
    constructor(optionalOptions = {}) {
        this._starsBlocks = document.querySelectorAll('.rating-stars--select');

        if (!this._starsBlocks) {
            this.destructor();
            return true;
        }

        let i;
        let ii;
        let stars

        this._starsBlocks.forEach((starsBlock) => {
            stars = starsBlock.querySelectorAll('span');

            stars.forEach((star) => {
                star.addEventListener("click", (event) => {

                    stars.forEach(function(starSpan) {
                        starSpan.classList.remove("active");
                    });

                    i = Array.prototype.indexOf.call(stars, star);

                    ii = 0;
                    for (ii; ii <= i; ++ii) {
                        stars[ii].className = 'active';
                    }

                    document.querySelector('input[name="rating"]').value = i + 1;
                });
            });
        })
    }

    destructor() {
        this._starsBlocks = null;
    }
}

export default new SelectRating();